import { ApiErrorMap } from './api-error-map';

const baseErrorKey = 'errors.routingProfiles.';

const routingProfileErrors = [
  [-1105, `${baseErrorKey}duplicateRoutingProfileName`],
  [-1013, `${baseErrorKey}routingProfileNameLengthExceeded`],
  [-1014, `${baseErrorKey}routingProfileNameConsecutiveWhitespaces`],
  [-1016, `${baseErrorKey}routingProfileNameSpecialCharacters`],
  [-1100, `${baseErrorKey}routingProfileCreateFailed`],
  [-1101, `${baseErrorKey}routingProfileUpdateFailed`],
  [-1017, `${baseErrorKey}invalidElevationLimit`],
  [-1015, `${baseErrorKey}invalidNameLeadingWhitespaces`],
  [-1021, `${baseErrorKey}invalidGovernorSpeedLimit`],
] as const;

export const routingProfileErrorMap: ApiErrorMap = new Map(
  routingProfileErrors
);

/**
 * t(errors.routingProfiles.duplicateRoutingProfileName)
 * t(errors.routingProfiles.routingProfileNameLengthExceeded)
 * t(errors.routingProfiles.routingProfileNameConsecutiveWhitespaces)
 * t(errors.routingProfiles.routingProfileNameSpecialCharacters)
 * t(errors.routingProfiles.routingProfileCreateFailed)
 * t(errors.routingProfiles.routingProfileUpdateFailed)
 * t(errors.routingProfiles.invalidElevationLimit)
 * t(errors.routingProfiles.invalidNameLeadingWhitespaces)
 * t(errors.routingProfiles.invalidGovernorSpeedLimit)
 */
